import React from 'react';
import {forBrands, styled} from '@core-ui/react-stitch';

const getDesktopStylesForGap = () => ({
  paddingTop: '7px',
  alignItems: 'flex-end',
});

const getDesktopStylesForOldNavy = () => ({
  paddingTop: '7px',
});

const getDesktopStylesForAthleta = () => ({
  paddingTop: '12px',
  alignItems: 'center',
  paddingBottom: '3px',
});

const getDesktopStyles = theme => forBrands(theme, {
  gap: getDesktopStylesForGap,
  gapfs: getDesktopStylesForGap,
  on: getDesktopStylesForOldNavy,
  at: getDesktopStylesForAthleta,
});

const TopBar = styled.div(({theme, isDesktop}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  ...isDesktop ? getDesktopStyles(theme) : {},
}));

export default TopBar;
